/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Search_Placeholder_Spaces_FilesInputs */



/**
* | output |
* | --- |
* | "Search spaces or files..." |
*
* @param {Spaces_Search_Placeholder_Spaces_FilesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_search_placeholder_spaces_files = /** @type {((inputs?: Spaces_Search_Placeholder_Spaces_FilesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Search_Placeholder_Spaces_FilesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Spaces oder Dateien durchsuchen...")
	return /** @type {LocalizedString} */ ("Search spaces or files...")
});